import { render, staticRenderFns } from "./MedRecordUpdateField.vue?vue&type=template&id=584ef7e4"
import script from "./MedRecordUpdateField.vue?vue&type=script&lang=js"
export * from "./MedRecordUpdateField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./MedRecordUpdateField.vue?vue&type=custom&index=0&blockType=styles&lang=scss&scoped=true"
if (typeof block0 === 'function') block0(component)

export default component.exports